import { call, put } from "redux-saga/effects"
import { push } from 'connected-react-router'
import axios from 'axios'
import config from '../config'

import { 
    fetchBoard,
    fetchBoardSuccess,fetchBoardFailed,
    createBoardSuccess,createBoardFailed,
    updateBoardSuccess,updateBoardFailed,
    deleteBoardSuccess,deleteBoardFailed,
    createCommentSuccess,createCommentFailed,
    deleteCommentSuccess,deleteCommentFailed,
    updateCommentSuccess,updateCommentFailed,
} from "../actions/board"


import { resetAuth } from "../actions/auth"

export function* fetchBoardDetail(action) {
    const id = action.payload
    const url = config.API_URL + `/board/${id}/comment`
    try {
        const response = yield axios({
            method: 'get',
            url: url,
        })
        if(response.data.successful){
            yield put(fetchBoardSuccess(response.data.boardcommentDetail))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(fetchBoardFailed(message))
    }
}

export function* createBoard(action) {
    const board = { ...action.payload }
    const url = config.API_URL + `/board`
    try {
        const { 
            title,
            category_id,
            detail
        } = board

        const formData = new FormData()
        formData.append("title",title)
        formData.append("detail",detail)
        formData.append("category_id",category_id)
       
        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
        })
        if(response.data.successful){
            yield put(createBoardSuccess(response.data.message))
            yield put(push(`/webboard`))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(createBoardFailed(message))
    }
}

export function* updateBoard(action) {
    const board = action.payload
    const id = board.id
    const url = config.API_URL + `/board/${id}`
    try {
        const { 
            title,
            category_id,
            detail
        } = board

        const formData = new FormData()
        formData.append("title",title)
        formData.append("detail",detail)
        formData.append("category_id",category_id)
        
        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
        })
        if(response.data.successful){
            yield put(updateBoardSuccess(response.data.message))
            yield put(push(`/topic/${id}`))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(updateBoardFailed(message))
    }
}

export function* deleteBoard(action) {
    const id = action.payload
    const url = config.API_URL + `/board/${id}/delete`
    try {
        const response = yield axios({
            method: 'post',
            url: url,
        })
        if(response.data.successful){
            yield put(deleteBoardSuccess(response.data.message))
            yield put(push(`/webboard`))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(deleteBoardFailed(message))
    }
}

export function* createComment(action) {
    const comment = action.payload 
    const id = comment.id
    const url = config.API_URL + `/board/${id}/comment`
    try {       
        const { 
            commentDetail
        } = comment

        const formData = new FormData()
        formData.append("detail",commentDetail)

        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
        })
        if(response.data.successful){
            yield put(createCommentSuccess(response.data.message))
            yield put(fetchBoard(id))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(createCommentFailed(message))
    }
}

export function* updateComment(action) {
    const comment = action.payload
    const id = comment.id
    const board_id = comment.board_id
    const url = config.API_URL + `/comment/${id}`
    try {
        const { 
            detail
        } = comment

        const formData = new FormData()
        formData.append("detail",detail)

        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
        })
        if(response.data.successful){
            yield put(updateCommentSuccess(response.data.message))
            yield put(fetchBoard(board_id))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(updateCommentFailed(message))
    }
}


export function* deleteComment(action) {
    const {comment_id, board_id} = action.payload
    const url = config.API_URL + `/comment/${comment_id}/delete`
    try {
        const response = yield axios({
            method: 'post',
            url: url,
        })
        if(response.data.successful){
            yield put(deleteCommentSuccess(response.data.message))
            yield put(fetchBoard(board_id))
        }
    }catch(error){
        let message = error.message
        if(error.response){
            message = error.response.data.message
            if(error.response.status === 401){
                yield put(resetAuth())
            }
        }
        yield put(deleteCommentFailed(message))
    }
}
